import * as React from 'react'
import { Checkbox } from '@mobiscroll/react-latest'
import { Field, FieldProps, FormikProps } from 'formik'

interface IField {
  onChange: (e: React.ChangeEvent<any>) => void
  onBlur: (e: any) => void
  value: any
  name: string
}

interface IFormikCheckboxProps {
  name: string
  value: any
  displayName: string
  checked?: (value: any) => boolean
}

const FormikCheckbox = <T extends {}>(props: IFormikCheckboxProps) => {
  const handleChange = (field: IField, form: FormikProps<T>) => () => {
    const userRoleIDs = field.value.map((role: any) => role)
    if (userRoleIDs.includes(props.value)) {
      const nextValue = field.value.filter((value: any) => {
        return value !== props.value
      })
      form.setFieldValue(props.name, nextValue)
    } else {
      const newRole = props.value
      const nextValue = [...field.value, newRole]
      form.setFieldValue(props.name, nextValue)
    }
  }

  return (
    <Field name={props.name}>
      {({ field, form }: FieldProps<T>) => (
        <div className='mt1 flex'>
          <Checkbox
            id={field.name + '-' + props.value}
            className='mr1'
            type='checkbox'
            {...field}
            checked={props.checked ? props.checked(props.value) : field.value.includes(props.value)}
            onChange={handleChange(field, form)}
          />
          <label htmlFor={field.name + '-' + props.value} className='font-grey3'>
            {props.displayName}
          </label>
        </div>
      )}
    </Field>
  )
}

export default FormikCheckbox



// WEBPACK FOOTER //
// ./src/components/ui/formik/Checkbox.tsx